import { Container } from "inversify";
import { dataModule } from "./modules/ioc.data.module";
import { sharedModule } from "./modules/ioc.shared.module";
import { dashboardModule } from "./modules/ioc.dashboard.module";
import { requirementsModule } from "./modules/ioc.requirements.module";
import { datafilterModule } from "./modules/ioc.datafilter.module";
import { datagridModule } from "./modules/ioc.datagrid.module";
import { validationModule } from "./modules/ioc.validation.module";
import { messagesModule } from "./modules/ioc.messages.module";
import { invoicesModule } from './modules/ioc.invoices.module'
import { customerModule } from "./modules/ioc.customer.module";
import { aresModule } from "./modules/ioc.ares.module";

export const inversifyContainer = new Container();
inversifyContainer.load(
    dataModule, 
    sharedModule, 
    dashboardModule, 
    requirementsModule,
    datafilterModule,
    datagridModule,
    validationModule,
    messagesModule,
    invoicesModule,
    customerModule,
    aresModule
);